// extracted by mini-css-extract-plugin
module.exports = {"tabsRoot":"Tabs_tabsRoot__iUO6B","tabsList":"Tabs_tabsList__7N46C","tabsTrigger":"Tabs_tabsTrigger__Gkq_a","addons":"Tabs_addons__oNLwO"};